module.exports = __webpack_public_path__ + "static/media/groceryListIcon6.69029c0a.svg";